export const LOCALE_STORAGE_KEY = 'zimark-locale'

export const SUPPORTED_LOCALES = ['en', 'ja', 'zh'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const DEFAULT_LOCALE: SupportedLocale = 'en'

export function normalizeLocale(input?: string | null): SupportedLocale {
  if (!input) return DEFAULT_LOCALE
  const lower = input.toLowerCase()
  if (lower.startsWith('ja')) return 'ja'
  if (lower.startsWith('zh')) return 'zh'
  if (lower.startsWith('en')) return 'en'
  return DEFAULT_LOCALE
}

export function localeToIntlTag(locale: SupportedLocale): string {
  switch (locale) {
    case 'ja':
      return 'ja-JP'
    case 'zh':
      return 'zh-CN'
    default:
      return 'en-US'
  }
}

/** Stripe Checkout Session `locale` values we support (en / ja / zh). */
export function toStripeCheckoutLocale(input?: string | null): SupportedLocale {
  return normalizeLocale(input)
}

/**
 * Resolve checkout UI language:
 * 1) Explicit account/UI preference (`zimark-locale` localStorage)
 * 2) Else i18n / browser-detected language
 */
export function resolveCheckoutLocale(i18nLanguage?: string | null): SupportedLocale {
  if (typeof window !== 'undefined') {
    try {
      const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY)
      if (stored) return normalizeLocale(stored)
    } catch {
      /* ignore */
    }
  }
  return normalizeLocale(i18nLanguage)
}
